export default "__VITE_PUBLIC_ASSET__b89c876a__"